import { Expense } from "@finway-group/shared/lib/models"
import React from "react"
import { useTranslation } from "react-i18next"

interface SimpleExpenseListProps {
    expenses: Array<Expense>
}

export const SimpleExpenseList = ({ expenses }: SimpleExpenseListProps) => {
    const { t } = useTranslation()

    return (
        <ul className="list-none my-20">
            {expenses.map((expense) => (
                <li key={expense.id}>
                    {t("label:request")} #{expense.expenseNumber}
                </li>
            ))}
        </ul>
    )
}
